@if (!finishedLoading) {
    <cb-loading-spinner class="cb-margin"></cb-loading-spinner>
}
@if (finishedLoading) {
    <cb-dialog dialogHeading="Manage Attribute Items">
        <div class="end-center flex-row">
            <button class="cb-margin-bottom" mat-raised-button (click)="expandCollapseAll()">
                @if (!allPanelsExpanded()) {
                    <span class="start-center flex-row">
                        <span>Expand All&nbsp;</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </span>
                }
                @if (allPanelsExpanded()) {
                    <span class="start-center flex-row">
                        <span>Collapse All&nbsp;</span>
                        <mat-icon>keyboard_arrow_up</mat-icon>
                    </span>
                }
            </button>
        </div>
        <div class="form-container">
            <form class="flex-col flex" #form="ngForm">
                <mat-accordion [multi]="true" class="accordion">
                    @for (group of groupedItems; track group) {
                        <mat-expansion-panel class="panel" [(expanded)]="group.expanded">
                            <mat-expansion-panel-header class="cb-padding-top cb-padding-bottom">
                                <mat-panel-title class="start-center flex-row">
                                    @if (group.anyEmptyItems()) {
                                        <mat-icon
                                            class="cb-error cb-help-cursor"
                                            matTooltip="Some Items Requiring Attributes"
                                            >panorama_fish_eye</mat-icon
                                        >
                                    }
                                    @if (!group.anyEmptyItems()) {
                                        <mat-icon
                                            class="mat-primary cb-help-cursor"
                                            matTooltip="All Item Attributes Set"
                                            >check_circle</mat-icon
                                        >
                                    }
                                    <span class="cb-margin-left mat-body-2">
                                        {{ group.label }}&nbsp;({{ group.items.length }})
                                    </span>
                                </mat-panel-title>
                                <mat-panel-description class="end-center flex-row">
                                    <button mat-icon-button (click)="togglePanelPinned(group.id)">
                                        <mat-icon
                                            svgIcon="pin"
                                            [ngClass]="{
                                                'cb-accent': userCacheItem.silentData[group.id]
                                            }"
                                        >
                                        </mat-icon>
                                    </button>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            @for (item of group.items; track item) {
                                <div class="cb-margin flex-col">
                                    <cb-table [loaded]="true">
                                        <thead cbTableHead>
                                            <tr>
                                                <td width="50%">
                                                    <div class="start-center flex-row">
                                                        <mat-icon
                                                            style="color: white"
                                                            title="{{ item.title }}"
                                                        >
                                                            {{ item.icon }}</mat-icon
                                                        >
                                                        <span class="mat-body-2"
                                                            >&nbsp; {{ item.label }}</span
                                                        >
                                                    </div>
                                                </td>
                                                <td width="50%"></td>
                                            </tr>
                                        </thead>
                                        <tbody cbTableBody>
                                            <tr style="height: 0px; min-height: 0px; max-height: 0px">
                                                <td
                                                    style="
                                                        background-color: white !important;
                                                        padding: 0;
                                                    "
                                                ></td>
                                                <td
                                                    [rowSpan]="item.notesRowSpan"
                                                    style="font-size: 12px"
                                                >
                                                    <cb-text-area
                                                        label="Notes"
                                                        [name]="'notes_' + item.id"
                                                        [(ngModel)]="item.notes"
                                                        [maxlength]="256"
                                                        [rows]="1"
                                                        (change)="
                                                            !item.hasChanged && attributeChanged(item)
                                                        "
                                                    >
                                                    </cb-text-area>
                                                </td>
                                            </tr>
                                            @for (attribute of item.attributes; track attribute) {
                                                <tr>
                                                    <td>
                                                        <cb-select
                                                            [label]="attribute.name"
                                                            [name]="
                                                                'attrName_' +
                                                                item.id +
                                                                attribute.attributeId
                                                            "
                                                            [(ngModel)]="
                                                                item.selectedOptions[
                                                                    attribute.attributeId
                                                                ]
                                                            "
                                                            [options]="attribute.options"
                                                            (change)="
                                                                !item.hasChanged &&
                                                                    attributeChanged(item)
                                                            "
                                                        >
                                                        </cb-select>
                                                    </td>
                                                </tr>
                                            }
                                            @if (item.manualColourEntryRequired) {
                                                <tr>
                                                    <td>
                                                        <cb-text-area
                                                            label="Manual Colour Entry"
                                                            [name]="'manualColour_' + item.id"
                                                            [(ngModel)]="item.colourName"
                                                            [maxlength]="256"
                                                            [rows]="1"
                                                            (change)="
                                                                !item.hasChanged &&
                                                                    attributeChanged(item)
                                                            "
                                                        >
                                                        </cb-text-area>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </cb-table>
                                </div>
                            }
                        </mat-expansion-panel>
                    }
                </mat-accordion>
                @if (groupedItems?.length < 1) {
                    <div class="cb-margin center-start flex-col flex">
                        <div class="center-center flex-row flex">
                            <mat-icon class="mat-accent">info</mat-icon>
                            <span class="mat-body-2"
                                >&nbsp;There are no Items that need an attribute selection for this
                                Lot</span
                            >
                        </div>
                    </div>
                }
            </form>
        </div>
        <div actions>
            <button
                mat-raised-button
                color="primary"
                (cbClick)="saveAll()"
                [clickLimit]="1"
                [disabled]="form.invalid || form.pristine || !itemsHaveChanged"
            >
                Save
            </button>
            <button mat-raised-button (click)="cancel(form.dirty || itemsHaveChanged)">Cancel</button>
        </div>
    </cb-dialog>
}
